import { useEffect, useState } from 'react';
import { BusinessDetails, DocumentUpload, LicenceActivities, ServciesOffered, Summary } from '../fragments/icons';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useCreateLicence } from '../../repositories/licences-repository';
import { LICENCE_INSPECTION_FEE } from '../../constants/fees';

import VerticalStepper from '../fragments/vertical-stepper';
import Button from '@/components/buttons/Button';
import BusinessForm from './business-details-form';
import DocumentsDetailsForm from './documents-details-form';
import SummaryDetailsForm from './summary-licence-details-form';
import SuccessfulApplicationCard from '../fragments/application-succefully-card';
import LicenceActivitiesForm from './licence-activities-form';
import LicenceServicesOfferedForm from './licence-services-offered-form';
import toast from 'react-hot-toast';

const LicenceApplicationForm = () => {
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [open, setOpen] = useState<boolean>(false);
    const {mutate,isPending,isSuccess} = useCreateLicence();
    const steps = [
        {
            step: 1,
            title: 'Business Details',
            isActive: currentStep === 1,
            isCompleted: currentStep > 1,
            image: <BusinessDetails isCompleted={currentStep > 1} isActive={currentStep === 1} />,
        },
        {
            step: 2,
            title: 'Licence Activities',
            isActive: currentStep === 2,
            isCompleted: currentStep > 2,
            image: <LicenceActivities isCompleted={currentStep > 2} isActive={currentStep === 2} />,
        },
        {
            step: 3,
            title: 'Servcies Offered',
            isActive: currentStep === 3,
            isCompleted: currentStep > 3,
            image: <ServciesOffered isCompleted={currentStep > 3} isActive={currentStep === 3} />,
        },
        {
            step: 4,
            title: 'Documents Upload',
            isActive: currentStep === 4,
            isCompleted: currentStep >= 4,
            image: <DocumentUpload isActive={currentStep === 4} />,
        },
        {
            step: 5,
            title: 'Summary',
            isActive: currentStep === 5,
            isCompleted: currentStep >= 5,
            image: <Summary isActive={currentStep === 5} />,
        },
    ]

    const handleNext = async () => {
        const isValid = await trigger(
            [
                "accommodationServices",
                "marineServices",
                "tourOperations",
                "firstName",
                "lastName",
                "taxClearancefromZRAandTRA",
                "cirtificateofIncorporation",
                "selectedServices",
                "principalBusinessLocationPhoneNumber",
                "projectName",
                "zone",
                "region",
                "district",
                "municipal"
            ]);
        if(!isValid){
            toast.error("Please fill all the required fields");
        }
        if (isValid) {
            if (currentStep < steps.length) {
                setCurrentStep((prevStep) => prevStep + 1);
            }
        }
    }

    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep((prevStep) => prevStep - 1);
        }
    }
    const methods = useForm<any>({
        defaultValues: {
        },
    })
    const {  trigger } = methods;


    const accomodationServices = methods.getValues("licenseSubCategoryIds");
    const selectedServices = methods.getValues("selectedServices");
    const businessName = methods.getValues("businessName");
    const physicalLocation = methods.getValues("physicalLocation");
    const tinNumber = methods.getValues("tin");
    const swimmingPool = methods.getValues("facility_swimming_pool");
    const restaurant = methods.getValues("facility_restaurant");
    const parking = methods.getValues("facility_parking");
    const conferenceRooms = methods.getValues("facility_conference_rooms");
    const baseFeeList = methods.getValues("licenseSubCategoryIds");

    const getTotalBaseFee = () => {
        let baseFee = 0;
        baseFeeList &&
            baseFeeList.forEach((el: any) => {
                if (el.baseFee) {
                    baseFee += parseInt(el.baseFee, 10); 
                }
            });
        return baseFee; 
    };

    const getTotalManagementFee = () => {
        let managementFee = 0;
        baseFeeList &&
            baseFeeList.forEach((el: any) => {
                if (el.managementFee) {
                    managementFee += parseInt(el.managementFee, 10); 
                }
            });
        return managementFee; 
    };

    const baseFee = getTotalBaseFee()
    const managementFee = getTotalManagementFee()
    // Client-side constant - the API exposes no inspection fee. See constants/fees.ts.
    const inspectionFee = LICENCE_INSPECTION_FEE;
    const totalFees = baseFee + managementFee + inspectionFee;

    const handleModalSubmit = () => {
        methods.handleSubmit(onSubmit)();
       
        setTimeout(() => {
            setShowPaymentForm(false)
        }, 5000);
  };
    
    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <BusinessForm />
                );
            case 2:
                return (
                    <LicenceActivitiesForm />

                );
            case 3:
                return (
                    <LicenceServicesOfferedForm />
                );
            case 4:
                return (
                    <DocumentsDetailsForm />
                );
            case 5:
                return (
                    <SummaryDetailsForm
                        accommodationServices={accomodationServices}
                        baseFee={baseFee}
                        managementFee={managementFee}
                        inspectionFee={`${inspectionFee}`}
                        totalFees={totalFees}
                        businessName={businessName}
                        physicalLocation={physicalLocation}
                        tin={tinNumber} facilityDetails={{
                            conferenceRooms: conferenceRooms,
                            parking: parking,
                            restaurant: restaurant,
                            swimmingPool: swimmingPool
                        }}
                        selectedServices={selectedServices}
                        showPaymentForm={showPaymentForm}
                        setShowPaymentForm={setShowPaymentForm}
                        handleModalSubmit={handleModalSubmit}
                    />
                );
            default:
                return null;
        }
    }

    const onSubmit: SubmitHandler<any> = (data) => {
         console.log(data,"Yes")
         mutate(data);
    };

    useEffect(() => {
        if (isSuccess) {
            setOpen(true);
        }
    }, [isSuccess])

    return (
        <div className="w-full">
            <>
                <SuccessfulApplicationCard
                    isOpen={open}
                    onClose={() => setOpen(false)}
                />
            </>
            <div className="flex justify-between items-center border-b border-gray-200 px-4 py-2">
                <div>
                    <span>Submit New Applications</span>
                </div>
                <div className="flex justify-between items-center gap-3 my-1">
                    <Button
                        type="button"
                        intent="default"
                        size="md"
                        onClick={handleBack}>
                        Back
                    </Button>
                    <Button
                        type="button"
                        intent="primary"
                        className={`${currentStep === steps.length && "hidden"}`}
                        size="md" onClick={handleNext}>
                        Continue
                    </Button>
                </div>
            </div>
            <div className="flex space-x-5 gap-5 px-4">
                <div>
                    <VerticalStepper
                        steps={steps}
                    />
                </div>
                <div className='mt-2 ml-10 w-full max-w-3xl'>
                    <FormProvider {...methods}>
                        <form
                            className='w-full'>
                            {renderStepContent()}
                            <div className='flex  justify-end w-full'>
                                <div>
                                    {currentStep === steps.length &&
                                        <Button
                                            type="button"
                                            onClick={()=>setShowPaymentForm(true)}
                                            intent="primary"
                                            loading={isPending}
                                            className='mt-3 w-full'
                                            size="md">
                                            Submit
                                        </Button>
                                    }
                                </div>
                            </div>
                        </form>
                    </FormProvider>
                </div>
            </div>
        </div>
    );
};

export default LicenceApplicationForm